/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "گزشتہ کل",
        "-2": "گزشتہ پرسوں",
        "0": "آج",
        "1": "آئندہ کل",
        "2": "آنے والا پرسوں",
        "future": {
          "one": "{0} دن میں",
          "other": "{0} دنوں میں"
        },
        "past": {
          "one": "{0} دن پہلے",
          "other": "{0} دنوں پہلے"
        }
      },
      "day-narrow": {
        "-1": "گزشتہ کل",
        "-2": "گزشتہ پرسوں",
        "0": "آج",
        "1": "آئندہ کل",
        "2": "آنے والا پرسوں",
        "future": {
          "one": "{0} دن میں",
          "other": "{0} دنوں میں"
        },
        "past": {
          "one": "{0} دن پہلے",
          "other": "{0} دن پہلے"
        }
      },
      "day-short": {
        "-1": "گزشتہ کل",
        "-2": "گزشتہ پرسوں",
        "0": "آج",
        "1": "آئندہ کل",
        "2": "آنے والا پرسوں",
        "future": {
          "one": "{0} دن میں",
          "other": "{0} دنوں میں"
        },
        "past": {
          "one": "{0} دن پہلے",
          "other": "{0} دن پہلے"
        }
      },
      "hour": {
        "0": "اس گھنٹے",
        "future": {
          "one": "{0} گھنٹے میں",
          "other": "{0} گھنٹے میں"
        },
        "past": {
          "one": "{0} گھنٹہ پہلے",
          "other": "{0} گھنٹے پہلے"
        }
      },
      "hour-narrow": {
        "0": "اس گھنٹے",
        "future": {
          "one": "{0} گھنٹے میں",
          "other": "{0} گھنٹوں میں"
        },
        "past": {
          "one": "{0} گھنٹہ پہلے",
          "other": "{0} گھنٹے پہلے"
        }
      },
      "hour-short": {
        "0": "اس گھنٹے",
        "future": {
          "one": "{0} گھنٹے میں",
          "other": "{0} گھنٹے میں"
        },
        "past": {
          "one": "{0} گھنٹے پہلے",
          "other": "{0} گھنٹے پہلے"
        }
      },
      "minute": {
        "0": "اس منٹ",
        "future": {
          "one": "{0} منٹ میں",
          "other": "{0} منٹ میں"
        },
        "past": {
          "one": "{0} منٹ پہلے",
          "other": "{0} منٹ پہلے"
        }
      },
      "minute-narrow": {
        "0": "اس منٹ",
        "future": {
          "one": "{0} منٹ میں",
          "other": "{0} منٹ میں"
        },
        "past": {
          "one": "{0} منٹ پہلے",
          "other": "{0} منٹ پہلے"
        }
      },
      "minute-short": {
        "0": "اس منٹ",
        "future": {
          "one": "{0} منٹ میں",
          "other": "{0} منٹ میں"
        },
        "past": {
          "one": "{0} منٹ پہلے",
          "other": "{0} منٹ پہلے"
        }
      },
      "month": {
        "-1": "گزشتہ ماہ",
        "0": "اس ماہ",
        "1": "اگلا مہینہ",
        "future": {
          "one": "{0} مہینہ میں",
          "other": "{0} مہینے میں"
        },
        "past": {
          "one": "{0} مہینہ پہلے",
          "other": "{0} مہینے پہلے"
        }
      },
      "month-narrow": {
        "-1": "گزشتہ ماہ",
        "0": "اس ماہ",
        "1": "اگلے ماہ",
        "future": {
          "one": "{0} ماہ میں",
          "other": "{0} ماہ میں"
        },
        "past": {
          "one": "{0} ماہ پہلے",
          "other": "{0} ماہ پہلے"
        }
      },
      "month-short": {
        "-1": "پچھلے مہینہ",
        "0": "اس مہینہ",
        "1": "اگلے مہینہ",
        "future": {
          "one": "{0} ماہ میں",
          "other": "{0} ماہ میں"
        },
        "past": {
          "one": "{0} ماہ قبل",
          "other": "{0} ماہ قبل"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "گزشتہ سہ ماہی",
        "0": "اس سہ ماہی",
        "1": "اگلے سہ ماہی",
        "future": {
          "one": "{0} سہ ماہی میں",
          "other": "{0} سہ ماہی میں"
        },
        "past": {
          "one": "{0} سہ ماہی پہلے",
          "other": "{0} سہ ماہی پہلے"
        }
      },
      "quarter-narrow": {
        "-1": "گزشتہ سہ ماہی",
        "0": "اس سہ ماہی",
        "1": "اگلے سہ ماہی",
        "future": {
          "one": "{0} سہ ماہی میں",
          "other": "{0} سہ ماہی میں"
        },
        "past": {
          "one": "{0} سہ ماہی پہلے",
          "other": "{0} سہ ماہی پہلے"
        }
      },
      "quarter-short": {
        "-1": "گزشتہ سہ ماہی",
        "0": "اس سہ ماہی",
        "1": "اگلے سہ ماہی",
        "future": {
          "one": "{0} سہ ماہی میں",
          "other": "{0} سہ ماہی میں"
        },
        "past": {
          "one": "{0} سہ ماہی قبل",
          "other": "{0} سہ ماہی قبل"
        }
      },
      "second": {
        "0": "اب",
        "future": {
          "one": "{0} سیکنڈ میں",
          "other": "{0} سیکنڈ میں"
        },
        "past": {
          "one": "{0} سیکنڈ پہلے",
          "other": "{0} سیکنڈ پہلے"
        }
      },
      "second-narrow": {
        "0": "اب",
        "future": {
          "one": "{0} سیکنڈ میں",
          "other": "{0} سیکنڈ میں"
        },
        "past": {
          "one": "{0} سیکنڈ پہلے",
          "other": "{0} سیکنڈ پہلے"
        }
      },
      "second-short": {
        "0": "اب",
        "future": {
          "one": "{0} سیکنڈ میں",
          "other": "{0} سیکنڈ میں"
        },
        "past": {
          "one": "{0} سیکنڈ پہلے",
          "other": "{0} سیکنڈ پہلے"
        }
      },
      "week": {
        "-1": "گزشتہ ہفتے",
        "0": "اس ہفتہ",
        "1": "اگلے ہفتے",
        "future": {
          "one": "{0} ہفتہ میں",
          "other": "{0} ہفتے میں"
        },
        "past": {
          "one": "{0} ہفتہ پہلے",
          "other": "{0} ہفتے پہلے"
        }
      },
      "week-narrow": {
        "-1": "پچھلے ہفتہ",
        "0": "اس ہفتہ",
        "1": "اگلے ہفتہ",
        "future": {
          "one": "{0} ہفتہ میں",
          "other": "{0} ہفتے میں"
        },
        "past": {
          "one": "{0} ہفتہ پہلے",
          "other": "{0} ہفتے پہلے"
        }
      },
      "week-short": {
        "-1": "پچھلے ہفتہ",
        "0": "اس ہفتہ",
        "1": "اگلے ہفتہ",
        "future": {
          "one": "{0} ہفتے میں",
          "other": "{0} ہفتے میں"
        },
        "past": {
          "one": "{0} ہفتے پہلے",
          "other": "{0} ہفتے پہلے"
        }
      },
      "year": {
        "-1": "گزشتہ سال",
        "0": "اس سال",
        "1": "اگلے سال",
        "future": {
          "one": "{0} سال میں",
          "other": "{0} سال میں"
        },
        "past": {
          "one": "{0} سال پہلے",
          "other": "{0} سال پہلے"
        }
      },
      "year-narrow": {
        "-1": "گزشتہ سال",
        "0": "اس سال",
        "1": "اگلے سال",
        "future": {
          "one": "{0} سال میں",
          "other": "{0} سال میں"
        },
        "past": {
          "one": "{0} سال پہلے",
          "other": "{0} سال پہلے"
        }
      },
      "year-short": {
        "-1": "گزشتہ سال",
        "0": "اس سال",
        "1": "اگلے سال",
        "future": {
          "one": "{0} سال میں",
          "other": "{0} سال میں"
        },
        "past": {
          "one": "{0} سال پہلے",
          "other": "{0} سال پہلے"
        }
      }
    },
    "locale": "ur"
  });
}